import React, { useContext } from "react";
import { ResourceContext } from "../../Service/Context/ResourceContext";
import ProfileContactInfo from "./ProfileContactInfo";

const ProfileContactInfoTopRight = () => {
  const { documentLayout } = useContext(ResourceContext);

  if (documentLayout && documentLayout.infoBoxPlacement !== "RIGHT") {
    return null;
  }
  return <ProfileContactInfo />;
};

export default ProfileContactInfoTopRight;
